export default "__VITE_ASSET__DRNAFGmf__"